// ============================================================================
// layer.eggDailys.index — the egg daily hub, off App's boot arrays
// ============================================================================
// Two obligations, and they arrived from two different owners.
//
//   layer.eggDailys.list     the hub's own full-history page sequence.
//                            Presenter-owned before — a first-page effect plus
//                            an auto-append effect over a `page`/`hasMore`
//                            cursor — so only the cursor's owner moved.
//   layer.eggDailys.groups   the ppp-layer-groups-v1 app_store blob, which
//                            reached this surface as the LAST former-eager
//                            value LayerEntry still threaded to any route.
//                            Removing that hand-off is what retires
//                            `eggdailys` from the frozen app_store consumer
//                            list in
//                            tests/fixtures/former-eager-dependencies.json.
//
// The hub and record share the canonical group directory for their selectors.
// Report list and by-id reads remain separate.
//
// Saved views are not an obligation here for the same reason they are not one
// on layer.dailys.index: useSavedViewsData owns that read for every surface
// that has a picker.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'layer.eggDailys.index',
  obligations: Object.freeze([
    Object.freeze({id: 'layer.eggDailys.list', owner: 'permanent'}),
    Object.freeze({id: 'layer.eggDailys.groups', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
